module.exports = __webpack_public_path__ + "img/17-10.6e412e29.jpg";